module.exports = __webpack_public_path__ + "img/mineBanners.6ad841f1.jpg";